/* eslint-disable no-dupe-keys */
export default {
  group_application: {
    name: '集团用户申请',
    // 属性（一般与对象内容匹配）
    prop: {
      process_number: '申请单号',
      group: '优惠集团',
      user: '申请用户',
      car: '申请车辆',
      effective_time: '生效时间',
      status: '审核状态',
      description: '申请备注',
      effective_status: '状态',
      created_at: '申请时间',
      updated_at: '更新时间',
      review_desc: '审核备注',
      plate_number: '车牌',
      vin: 'VIN'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      process_number: '申请单号',
      group_id: '优惠集团',
      user_id: '申请用户',
      car_id: '申请车辆',
      status: '审核状态',
      description: '申请备注',
      latest_group_application_transition_id: '审核信息',
      last_review_admin_id: '审核人',
      effective_time: '生效时间',
      effective_begin_time: '生效开始时间',
      effective_end_time: '生效结束时间',
      effective_status: '状态',
      created_at: '申请时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    statuses: {
      pending: '待审核',
      passed: '已通过',
      rejected: '已拒绝',
      disabled: '已禁用'
    },
    effective_statuses: {
      pending: '待生效',
      available: '生效中',
      expired: '已过期',
      disabled: '已失效'
    },
    transitions: {
      pass: '审核通过',
      reject: '拒绝',
      disable: '禁用用户',
      repass: '重新通过'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询单号/车牌号/VIN',
      input_review_desc: 'App可见'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    titles: {
      base: '基础信息',
      orders: '最新充电记录',
      change_state: '审核提示'
    },
    tips: {
      before_passed: '操作前请先确认用户信息是否匹配',
      before_rejected: '拒绝后，需要用户重新申请',
      before_disabled: '禁用后，虽然用户在集团名单内，但不能使用集团优惠',
      effective_time: '留空则表示跟集团有效时间一致',
      empty_effective_time: '与集团有效时间一致'
    },
    list_tabs: {
      all: '全部',
      pending: '待审核',
      passed: '已通过',
      rejected: '已拒绝',
      disabled: '已禁用'
    }
  }
}
